<template>
  <div>
    <a-card class="margin-top-20">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        formLayout="inline"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>
    <a-card class="margin-top-20">
      <div class="text-right">
        <a-button type="primary" icon="download" @click="exportFile">
          下载
        </a-button>
      </div>
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="风险客户清单">
          <TableView
            ref="table"
            :data="tableData"
            :columns="tableColumns"
            :pagination="pageData"
            rowKey="id"
            :loading="tableLoading"
            :scroll="{ x: 800 }"
            @handlePagination="handleClickPage"
          ></TableView>
        </a-tab-pane>
        <a-tab-pane key="2" tab="历史修改记录">
          <TableView
            ref="table"
            :data="tableHistoryData"
            :columns="tableHistoryColumns"
            :pagination="pageHistoryData"
            :loading="tableHistoryLoading"
            rowKey="id"
            :scroll="{ x: 800 }"
            @handlePagination="handleHistoryClickPage"
          ></TableView>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import mixin from './mixin'
import cloneDeep from 'lodash/cloneDeep'
import {
  getRegionList,
  getListCManager,
  getBusinessList,
  getTableData,
  getRiskList,
  download,
  getHistoryTableData,
} from './api'
import { TableView, SearchView } from 'lxfintech-fe'
import moment from 'moment'
const CREDIT_MODEL_TYPE = 3
export default {
  mixins: [mixin],
  data() {
    //这里存放数据
    return {
      modelList: [],
      tableData: [],
      show: '1',
      tableHistoryLoading: false,
      tableLoading: false,
      tableHistoryData: [],
    }
  },
  components: { TableView, SearchView },

  //方法集合
  methods: {
    async _getRiskList() {
      const { data } = await getRiskList()
      this.searchSchema[2].selectList = data.map(item => {
        return {
          text: item.name,
          value: item.name,
        }
      })
    },
    callback(key) {
      this.show = key
    },
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1 // 设置为第一页
      if (this.show === '1') {
        this._getTableData(this.searchForm)
      } else {
        this._getHistoryTableData(this.searchForm)
      }
    },
    // 下载
    exportFile() {
      const params = this.getSearchParam(this.searchForm)
      download(params)
    },
    //下载查询信息
    getSearchParam(searchForm) {
      let search = cloneDeep(searchForm)
      search.type = this.show
      return { ...search }
    },
    async _getBusinessList() {
      try {
        const { data } = await getBusinessList()
        this.searchSchema[4]['selectList'] = data.map(item => {
          return {
            text: item.name,
            value: item.id,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    //信用主管
    async _getListCManager() {
      try {
        const { data } = await getListCManager()
        this.searchSchema[3]['selectList'] = data.map(item => {
          return {
            text: item.name + '-' + item.username,
            value: item.username,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    // 获取业务模式列表
    async _getRegionList(pid, type) {
      try {
        const { data } = await getRegionList({ pid, type })
        this.modelList = data.map(item => ({
          text: item.name,
          value: item.id,
        }))
        this.modelList.unshift({ text: '全部', value: '' })
        this.searchSchema[5]['selectList'] = this.modelList
      } catch (error) {
        console.log(error)
      }
    },
    handleModelChange(option) {
      if (option === undefined) {
        this.searchSchema[5]['selectList'] = []
        return
      }
      this._getRegionList(option, CREDIT_MODEL_TYPE)
    },

    async _getHistoryTableData(searchForm) {
      try {
        this.tableHistoryLoading = true
        const { current, pageSize } = this.pageHistoryData
        const query = {
          ...searchForm,
          type: 2,
          size: pageSize,
          current,
        }
        const {
          data: { total, records },
        } = await getHistoryTableData(query)
        this.pageHistoryData.total = total
        this.tableHistoryData = records
        this.tableHistoryData.map(item => {
          item.createTime = moment(item.createTime).format('YYYY-MM-DD')
          item.updateTime = moment(item.updateTime).format('YYYY-MM-DD')
        })
        this.tableHistoryLoading = false
      } catch (error) {
        this.tableHistoryLoading = false
      }
    },
    async _getTableData(searchForm) {
      try {
        this.loading = true
        const { current, pageSize } = this.pageData
        const query = {
          ...searchForm,
          type: 1,
          size: pageSize,
          current,
        }
        const {
          data: { total, records },
        } = await getTableData(query)
        this.pageData.total = total
        this.tableData = records
        this.tableData.map(item => {
          item.createTime = moment(item.createTime).format('YYYY-MM-DD')
        })
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
  },

  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getBusinessList()
    this._getRiskList()
    this._getTableData()
    this._getListCManager()
    this._getHistoryTableData()
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
